import Box from '@mui/material/Box';

const Layout = ({ children }) => {
  return (
    <Box
      sx={{
        margin: '0 auto',
        maxWidth: 900,
        padding: { xs: 2, sm: 2.5 },
      }}
    >
      {children}
    </Box>
  );
};

export default Layout;
